// Thin localStorage wrapper. Isolated so persistence could be swapped for
// Netlify Blobs later without touching UI or store code.

const PREFIX = "signal-room:";

export function load<T>(key: string, fallback: T): T {
  try {
    const raw = localStorage.getItem(PREFIX + key);
    return raw === null ? fallback : (JSON.parse(raw) as T);
  } catch {
    return fallback;
  }
}

export function save<T>(key: string, value: T): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(value));
  } catch {
    // Quota or private-mode failures are non-fatal for a demo workspace.
  }
}
